// Import SVG files as raw text and export them via a simple map
import add_big from './add_big.svg?raw';
import add_small from './add_small.svg?raw';
import ai from './ai.svg?raw';
import arrow_drop_down from './arrow_drop_down.svg?raw';
import arrow_drop_up from './arrow_drop_up.svg?raw';
import arrow_left from './arrow_left.svg?raw';
import book from './book.svg?raw';
import bug from './bug.svg?raw';
import calendar from './calendar.svg?raw';
import check from './check.svg?raw';
import check_circle from './check_circle.svg?raw';
import chevron_back from './chevron_back.svg?raw';
import chevron_forward from './chevron_forward.svg?raw';
import chevron_down from './chevron_down.svg?raw';
import close from './close.svg?raw';
import detection_off from './detection_off.svg?raw';
import detection_on from './detection_on.svg?raw';
import edit from './edit.svg?raw';
import flag from './flag.svg?raw';
import home from './home.svg?raw';
import import_icon from './import.svg?raw';
import info from './info.svg?raw';
import left_panel_close from './left_panel_close.svg?raw';
import lock from './lock.svg?raw';
import minus from './minus.svg?raw';
import notifications from './notifications.svg?raw';
import nut from './nut.svg?raw';
import pause from './pause.svg?raw';
import play_arrow from './play_arrow.svg?raw';
import pointer from './pointer.svg?raw';
import question_mark from './question_mark.svg?raw';
import schedule from './schedule.svg?raw';
import school from './school.svg?raw';
import signal_wifi_off from './signal_wifi_off.svg?raw';
import surgery from './surgery.svg?raw';
import timelapse from './timelapse.svg?raw';
import timer from './timer.svg?raw';
import user from './user.svg?raw';
import warning from './warning.svg?raw';

import type { IconName } from './types';

export const icons: Record<IconName, string> = {
  add_big,
  add_small,
  ai,
  arrow_drop_down,
  arrow_drop_up,
  arrow_left,
  book,
  bug,
  calendar,
  check_circle,
  check,
  chevron_back,
  chevron_forward,
  chevron_down,
  close,
  detection_off,
  detection_on,
  edit,
  flag,
  home,
  import: import_icon,
  info,
  left_panel_close,
  lock,
  minus,
  notifications,
  nut,
  pause,
  play_arrow,
  pointer,
  question_mark,
  schedule,
  school,
  signal_wifi_off,
  surgery,
  timelapse,
  timer,
  user,
  warning,
};

export type { IconName } from './types';
